export default "__VITE_ASSET__D0fKdSM0__"